// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1FuA4","search":"Settings_search__1VCPY","filter":"Settings_filter__3mQ63"};